import {Component, HostBinding, Inject, Injector, OnInit, ViewEncapsulation} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {BaseComponent} from '../../../base.component';
import {animationSlideInOut} from '../../../../util/animation/animation.slideInOut';
import {DataResponse} from '../../../../network/service/data.response';
import {SnackBarUtil} from '../../../../util/snack.bar.util';

@Component({
  selector: 'app-register-comment',
  standalone: false,
  templateUrl: './register-comment.component.html',
  styleUrl: './register-comment.component.scss',
  animations: [animationSlideInOut],
  encapsulation: ViewEncapsulation.None,
})
export class RegisterCommentComponent extends BaseComponent implements OnInit {
  @HostBinding('@slideInOut') animationState = 'open';
  rating: number = 0;
  comment: string = '';

  constructor(injector: Injector, public dialogRef: DialogRef<string>, @Inject(DIALOG_DATA) public data: any) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  noAction() {
    this.animationState = 'closed';
    setTimeout(() => {
      this.dialogRef.close();
    }, 400);
  }

  onSubmitClicked() {
    this.serviceApi.submitComment({
      FactorId: this.data.FactorId,
      Comment: this.comment,
      Rate: this.rating,
    }).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.dialogRef.close();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
